import React from 'react';
import { CommonProp } from '@acin/ui-core';
import { TestIdProp, generate } from '../../../helpers/testId';
import * as SC from './CheckboxCard.styled';

export interface CheckboxCardProps extends TestIdProp, CommonProp {
  className?: string;
  onChange?: () => void;
  onCardClick?: () => void;
  isChecked?: boolean;
  isActive?: boolean;
  id: string;
  type?: 'checkbox' | 'radio';
}

export const CheckboxCard: React.FC<CheckboxCardProps> = (props) => {
  const { className, children, onChange, onCardClick, isChecked, isActive, id, type = 'checkbox' } = props;

  const handleChange = () => onChange?.();
  const handleCardClick = () => (onCardClick ? onCardClick() : onChange?.());

  return (
    <SC.CheckboxCard
      onClick={handleCardClick}
      isActive={isActive ?? isChecked}
      data-testid={generate([`checkbox-card-${id}`], props)}
      className={className}
    >
      {onChange && (
        <label onClick={(e) => e.stopPropagation()}>
          {type === 'radio' ? (
            <SC.RadioInput onChange={() => handleChange()} isChecked={isChecked} />
          ) : (
            <SC.CheckboxInput onChange={() => handleChange()} isChecked={isChecked} />
          )}
        </label>
      )}
      <SC.Content>{children}</SC.Content>
    </SC.CheckboxCard>
  );
};
